import loadable from "@loadable/component";

export const TempAccessList = loadable(() => import("./list"));

export const TempAccessCodeList = loadable(() => import("./codeList"));
